import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { deleteManufacturer } from '../../../../crud/manufacturer.crud';

export const useDeleteManufacture = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleManufacture = async (id: number) => {
    setLoading(true);
    deleteManufacturer(id)
      .then(() => {
        setSuccess(true);
        enqueueSnackbar(`Производитель успешно удален`, {
          variant: 'success',
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 100);
      });
  };
  return { handleManufacture, loading, success };
};
